let userProfile = null;
let sessionExpiredCallback = null;

export const setSessionExpiredCallback = (callback) => {
  sessionExpiredCallback = callback;
};

export const getUserProfile = (userId) => {
  if (!userId) return userProfile;
  
  if (userProfile && userProfile.id === userId) {
    return userProfile;
  }
  
  if (userId === "lucent@applucent.com") {
    return {"id": "lucent@applucent.com", "first_name": "Lucent", "last_name": ""};
  }
  
  return null;
};

export const isAuthenticated = async () => {
  const token = await getAccessToken()
  // console.log("isAuthenticated: token = "+token);
  return token !== null;
};

export const getAccessToken = async () => {
  const cookies = document.cookie.split(';');
  const tokenCookie = cookies.find(cookie => cookie.trim().startsWith('access-token='));
  // console.log("getAccessToken: tokenCookie = "+tokenCookie);
  const token = tokenCookie ? tokenCookie.split('=')[1] : null;

  // console.log("getAccessToken: token = "+token);
  
  // return "a string";
  // return null
  // if (!token) return null;
  if (!token)
  {
    console.error('No token found or token has expired');
    if (sessionExpiredCallback && window.location.pathname !== '/login') {
      sessionExpiredCallback({
        message: 'Session has expired'
      });
    }
    return null;
  }
  
  try {
    const response = await fetch(`${process.env.REACT_APP_ORCHESTRATOR_LOGIN}/validate_token`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Access-Control-Allow-Origin': '*'
      }
    });

    if (response.ok) {
      userProfile = await response.json();
      return token;
    } else {
      const errorData = await response.json();
      console.error('Token validation failed:', errorData.message || 'Unknown error');
      if (sessionExpiredCallback && userProfile) {
        sessionExpiredCallback({
          firstName: userProfile.first_name,
          lastName: userProfile.last_name,
          userId: userProfile.id,
          message: errorData.message || 'Session expired'
        });
      }
      userProfile = null;
      return null;
    }
  } catch (error) {
    userProfile = null;
    return null;
  }
};